import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCwIcon, UserPlusIcon } from 'lucide-react';
export function OngoingSection() {
  return <section className="py-24 bg-white border-b border-neutral-200" data-id="element-176">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-177">
        <div className="bg-background rounded-3xl p-8 md:p-16 border border-neutral-200 relative overflow-hidden" data-id="element-178">
          {/* Decorative background element */}
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent/5 rounded-full blur-3xl pointer-events-none" data-id="element-179" />

          <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-180">
            <div data-id="element-181">
              <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-182">
                Ongoing Support
              </h2>
              <p className="text-lg text-neutral-600 mb-8" data-id="element-183">
                Technology moves fast. We ensure your team never falls behind
                with continuous education and onboarding.
              </p>

              <div className="space-y-6" data-id="element-184">
                <div className="flex gap-4" data-id="element-185">
                  <div className="w-10 h-10 rounded-full bg-white border border-neutral-200 flex items-center justify-center shrink-0" data-id="element-186">
                    <UserPlusIcon className="w-5 h-5 text-foreground" data-id="element-187" />
                  </div>
                  <div data-id="element-188">
                    <h4 className="font-bold mb-1" data-id="element-189">New Hire Onboarding</h4>
                    <p className="text-sm text-neutral-600" data-id="element-190">
                      Every new employee gets certified on your custom AI stack
                      from day one.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-191">
                  <div className="w-10 h-10 rounded-full bg-white border border-neutral-200 flex items-center justify-center shrink-0" data-id="element-192">
                    <RefreshCwIcon className="w-5 h-5 text-foreground" data-id="element-193" />
                  </div>
                  <div data-id="element-194">
                    <h4 className="font-bold mb-1" data-id="element-195">Refresh Training</h4>
                    <p className="text-sm text-neutral-600" data-id="element-196">
                      Optional quarterly updates on new Claude capabilities and
                      agent workflows.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative h-full min-h-[300px] rounded-2xl border border-neutral-200 bg-white overflow-hidden flex items-center justify-center" data-id="element-197">
              <div className="absolute inset-0 bg-[radial-gradient(#e5e5e5_1px,transparent_1px)] [background-size:16px_16px] opacity-30" data-id="element-198" />
              <motion.div className="relative z-10 w-32 h-32 rounded-full border-4 border-neutral-100 flex items-center justify-center" animate={{
              rotate: 360
            }} transition={{
              duration: 20,
              repeat: Infinity,
              ease: 'linear'
            }} data-id="element-199">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-accent rounded-full shadow-[0_0_15px_rgba(234,88,12,0.5)]" data-id="element-200" />
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-foreground rounded-full" data-id="element-201" />
                <div className="w-16 h-16 rounded-full bg-neutral-50 border border-neutral-200 flex items-center justify-center" data-id="element-202">
                  <RefreshCwIcon className="w-6 h-6 text-neutral-400" data-id="element-203" />
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}